import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'

function MasterclassesWorkshops() {
    return (
        <div>
            <h2>Masterclasses/Workshops</h2>
            <p>To compliment conference program IETBHEC’27 program committee is offering interactive Masterclasses workshops. The intended workshops should fall within the scope of IETBHEC'27 and should be of 2 hours duration. Academics, researchers and practitioners wishing to organise interactive workshops should submit workshop proposal/s using our submission link from IETBHEC’27 Website. </p>
            {/* <div className="px-5">
                <ul>
                    <li>Masterclass/Workshop Title</li>
                    <li>Duration (2 hours suggested)</li>
                    <li>A Technical Description of the Masterclass Topic Area</li>
                    <li>A Brief Statement of the relevance of the Proposed Masterclass</li>
                </ul>
            </div> */}

            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>
        </div>
    )
}

export default MasterclassesWorkshops